import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'modules';
import FormModal from './FormModal';
import SubmitModal from './SubmitModal';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { selectConsultantAccess, selectOnlineFormContract } from 'stores/onlineForm/onlineForm';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

const Partner = () => {
  const wsContext = useContext(WebsocketContext);

  const contract = useSelector(selectOnlineFormContract);
  const isConsultantAccess = useSelector(selectConsultantAccess);

  // modal s formulářem s daty partnera
  const [showFormModal, setShowFormModal] = useState(false);
  // malé konfirmační okno pro potvrzení zda přidat či nepřidat partnera
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const toggleShowConfirmModal = () => {
    setShowConfirmModal(!showConfirmModal);
  };

  const handleShowFormModal = () => {
    // skrytí konfirmace, a zobrazení modalu
    setShowConfirmModal(false);
    setShowFormModal(true);
    // refresh smlouvy
    wsContext?.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
    // zobrazení modalu s formulářem partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_FORM_OPEN,
      value: true,
    });
  };

  const handleCloseFormModal = () => {
    // skrytí modalu s formularem
    setShowFormModal(false);
    // refresh smlouvy
    wsContext?.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
    // zobrazení modalu s formulářem partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_FORM_OPEN,
      value: false,
    });
  };

  useEffect(() => {
    wsContext?.ws?.on(WebsocketActions.CONTRACT_PARTNER_FORM_OPEN, setShowFormModal);
    return () => {
      wsContext?.ws?.off(WebsocketActions.CONTRACT_PARTNER_FORM_OPEN);
    };
    // eslint-disable-next-line
  }, []);

  // 2. klient je u smlouvy zadán
  if (!!contract?.client2 && contract?.client2?.prijmeni) {
    return null;
  }

  return (
    <>
      {isConsultantAccess && (
        <Row>
          <Col>
            <Button className="mb-3" variant="primary" onClick={toggleShowConfirmModal}>
              Pridať manžela / manželku
            </Button>
          </Col>
        </Row>
      )}
      {/*
      // TODO: identifikace 2. klienta musí být ve formuláři, jako mezikrok
      // TODO: ke smlouvě se uloží, jakmile bude potvrzen modal s partnerem (souhlas)
      */}
      {showFormModal && <FormModal onClose={handleCloseFormModal} />}
      {showConfirmModal && <SubmitModal onSubmit={handleShowFormModal} onClose={toggleShowConfirmModal} />}
    </>
  );
};

export default Partner;
